// pages/Dashboard.jsx
import EcoCredits from "../../components/home/EcoCredits";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <EcoCredits />
    </HomeLayout>
  );
}
